import React, { FC, useCallback } from 'react';
import { error as logError } from '../../error';

export interface ErrorHandlerProps { }

const ErrorHandler: FC<ErrorHandlerProps> = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const errorCb = useCallback((messageOrEvent: any, source: string, line: number, column: number, error: any) => {
    logError('error', {
      messageOrEvent,
      source,
      line,
      column,
      error,
    });
  }, []);

  React.useEffect(() => {
    window.onerror = errorCb;
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => { window.onerror = () => { }; };
  }, [errorCb]);

  return (null);
};

export default ErrorHandler;
